export default __webpack_public_path__ + "static/media/Flag_of_Vietnam.224110cb.svg";